import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="email"
export default class extends Controller {
  static targets = [ "emails", "addLink", "removeLink", "template" ]

  connect() {
    super.connect();
    if (this.emailsTarget.children.length === 0) {
      this.addEmail();
    }
  }

  addEmail(event) {
    if (event) event.preventDefault();
    const content = this.templateTarget.innerHTML.replace(/NEW_RECORD/g, new Date().getTime());
    this.emailsTarget.insertAdjacentHTML('beforeend', content);
  }

  removeEmail(event) {
    event.preventDefault()

    let wrapper = event.target.closest(".nested-fields")
    if (wrapper.dataset.newRecord == 'true') {
      wrapper.remove()
    } else {
      wrapper.querySelector(".destroy-field").value = '1'
      wrapper.style.display = 'none'
    }
  }
}
